
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-5b004036\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../vue-loader/lib/selector?type=styles&index=0!./modal.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./modal.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/modal.vue
// module id = 538
// module chunks = 0